<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form">
      <!--begin::Form-->
      <!-- CR-PM-2026 Issue 14: move ref="form" จาก div → form เพื่อให้ jquery.validate bind ถูก element -->
      <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <div class="col-xl-6">
                <div class="form-group">
                  <label>รหัสตัวแทนจำหน่าย :</label>
                  <span class="form-control-plaintext">{{ agentCode }}</span>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label>ชื่อตัวแทนจำหน่าย :</label>
                  <span class="form-control-plaintext">{{ agentName }}</span>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label>ที่อยู่ :</label>
                  <span class="form-control-plaintext">{{ adress }}</span>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label>ประเภทตัวแทนจำหน่าย:</label>
                  <treeselect v-model="OwnerTypeCode" :options="OwnerTypeCodeOption"
                    :clear-on-select="true" placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label>เขตการขาย :</label>
                  <span class="form-control-plaintext">{{ Area }}</span>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label>เขตการขาย(เบียร์สด) :</label>
                  <select2
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'auAreaNew'"
                    :name="'auAreaNew'"
                    :select2-options="auAreaNewOptions"
                    v-model="auAreaNew"
                    ref="auAreaNewSelect2"
                  ></select2>
                  <span class="form-text"></span>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label>จังหวัด :</label>
                  <span class="form-control-plaintext">{{ Province }}</span>
                </div>
              </div>
              <!-- <div class="col-xl-12">
                <div class="form-group">
                  <label>เขตการขาย :</label>
                  <select
                    id="Area"
                    name="Area"
                    class="form-control m-select2"
                    style="width: 100%;"
                    readonly
                  ></select>
                </div>
              </div>-->
              <!-- <div class="col-xl-12">
                <div class="form-group">
                  <label>จังหวัด :</label>
                  <select
                    id="Province"
                    name="Province"
                    class="form-control m-select2"
                    style="width: 100%;"
                  ></select>
                </div>
              </div>-->
              <div class="col-xl-6">
                <div class="form-group">
                  <label>ชื่อเจ้าของ :</label>
                  <span class="form-control-plaintext">{{ agentOnwer }}</span>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label>เบอร์โทร :</label>
                  <span class="form-control-plaintext">{{ tel }}</span>
                  <!-- <input
                    id="tel"
                    name="tel"
                    v-model="tel"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="เบอร์โทร"
                  /> -->
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label>Email :</label>
                  <!-- <span class="form-control-plaintext">{{ email }}</span> -->
                  <input
                    id="email"
                    name="email"
                    v-model="email"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="Email"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6">
                <div class="form-group">
                  <label>ชื่อผู้ติดต่อ :</label>
                  <span class="form-control-plaintext">{{ agentContact }}</span>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label>เบอร์โทรผู้ติดต่อ :</label>
                  <span class="form-control-plaintext">{{ agentContactTel }}</span>
                </div>
              </div>
            </div>

            <!-- Begin: CR-PM-2026 Req 2 — ตั้งค่าระยะ Check-In/Check-Out -->
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="label-required">ตั้งค่าระยะ Check-In/Check-Out:</label>
                  <small class="text-danger ml-2">*ทำไว้เผื่ออนาคตมีการทำงานที่ต้องเข้า Check-In ที่ตัวแทนจำหน่าย</small>
                  <div>
                    <label class="kt-radio kt-radio--bold kt-radio--brand" style="margin-right: 30px;">
                      <input type="radio" v-model="useSettingCheckinRange" :value="true" /> กำหนดตามตั้งค่าพื้นฐาน
                      <span></span>
                    </label>
                    <label class="kt-radio kt-radio--bold kt-radio--brand">
                      <input type="radio" v-model="useSettingCheckinRange" :value="false" /> กำหนดเอง
                      <span></span>
                    </label>
                    <button v-if="!useSettingCheckinRange" type="button" class="btn btn-sm btn-clean btn-icon"
                      @click="resetCheckinRange" title="ใช้ค่า default">
                      <i class="la la-times"></i>
                    </button>
                  </div>
                  <!-- Issue 2: defensive UI -->
                  <div v-if="useSettingCheckinRange && apiLoadedCheckInRange === null" class="alert alert-warning mt-2" style="max-width: 500px;">
                    <i class="la la-exclamation-triangle"></i> ให้ไป apply ค่าที่หน้า ตั้งค่าพื้นฐาน
                  </div>
                  <div v-if="!useSettingCheckinRange" class="mt-2" style="max-width: 300px;">
                    <label class="label-required">ระยะ (เมตร):</label>
                    <input type="number" min="1" max="10000" v-model.number="customCheckInRange"
                      class="form-control" placeholder="ระบุระยะ (เมตร)" name="customCheckInRange"
                      @input="checkCustomCheckInRangeMax" @change="checkCustomCheckInRangeMax" />
                    <span v-if="customCheckInRangeMaxError" class="text-danger small">{{ customCheckInRangeMaxError }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- End: CR-PM-2026 Req 2 -->

            <div class="row">
              <!-- Begin:Map element -->
              <div class="col-xl-6">
                <div class="form-group">
                  <label>ตำแหน่งที่ตั้ง:</label>
                  <div v-if="lat === null">
                    <button type="button" class="btn m-btn--pill btn-info btn-block col-xl-4 col-lg-4 col-md-4 col-sm-4" @click="getMap">
                      ระบุข้อมูลตำแหน่งที่ตั้ง
                    </button>
                  </div>
                  <div v-else>
                    <GmapMap
                      :center="{ lat: lat, lng: lng }"
                      :zoom="15"
                      :clickable="true"
                      @click="updateCoordinates"
                      style="width: 500px; height: 300px"
                    >
                      <gmap-marker
                        :key="index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        :draggable="true"
                        @drag="updateCoordinates"
                        :clickable="true"
                        @click="updateCoordinates"
                      ></gmap-marker>
                    </GmapMap>
                    <br />
                    <div>
                      <button type="button" class="btn btn-sm btn-secondary" @click="openMap()"><i class="far fa-map"></i> Open GoogleMaps</button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-6">
                <div class="form-group">
                  <label>แจ้งเตือน Email คงค้างถัง,ท่อ (รายงาน Stock รายบาร์โค้ด):</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input type="checkbox" class="form-check-input" v-model="IsSendReport" name="IsSendReport" id="IsSendReport" />
                      <span></span>
                      เปิดใช้งานแจ้งเตือน Email คงค้างถัง,ท่อ (รายงาน Stock รายบาร์โค้ด)
                    </label>
                  </div>
                </div>
              </div>  

               <div class="col-xl-6">
              <div class="form-group">
                <label
                  >รูปภาพ:<span class="text-sm text-danger" style="font-size:small">
                    (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน 10Mb.)</span
                  ></label
                >
                <button
                  type="button"
                  class="btn m-btn--pill btn-info btn-block uploader-btn col-xl-4 col-lg-4 col-md-4 col-sm-4"
                  @click="uploadFile"
                >
                  <i class="flaticon-upload-1"></i>รูป
                </button>
                <div class="row" style="margin-top: 2%;" id="container-img">
                  <div v-for="image in FileUpload"
                       :key="image.pictureId"
                       v-if="image.isLoaded"
                       class="col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap"
                       :id="image.pictureId">
                    <img :src="image.urlImg"
                         class="img-agent -avatar js-avatar-me img-thumbnail card-img-top"
                         @error="handleImageError(image)"
                         @load="handleImageLoad(image)" />
                    <a href="javascript:;"
                       style="position:absolute;top:10px;right:20px;"
                       class="btn m-btn--pill btn-danger m-btn btm-remove-img-agent close"
                       @click="removeImage(image.pictureId)">
                      <span class="m--font-inverse-danger la la-trash"></span>
                    </a>
                  </div>
                </div>
              </div>
            </div> 
            <div class="col-xl-6">
                  <div class="form-group">
                    <label>แสดงข้อมูลตัวแทนจำหน่ายในรายงาน (Module ข้อมูลคะแนนตัวแทนจำหน่าย):</label>
                    <div class="form-check">
                      <label class="form-check-label kt-checkbox">
                        <input type="checkbox" class="form-check-input" v-model="isShowInAgentScoreReport" name="isShowInAgentScoreReport" id="isShowInAgentScoreReport" />
                        <span></span>
                        เปิดใช้งาน
                      </label>
                    </div>
                  </div>
                </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label>[PM] ตั้งค่าใช้ PM (รูปแบบพิเศษ):</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input type="checkbox" class="form-check-input" v-model="IsSpecialPM" name="IsSpecialPM" id="IsSpecialPM" />
                      <span></span>
                      เปิดใช้งาน PM (รูปแบบพิเศษ)
                    </label>
                  </div>
                </div>
              </div>

               <div class="col-xl-6">
              <div class="form-group">
                <label>สถานะตัวแทนจำหน่าย:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input type="checkbox" class="form-check-input" v-model="agentStatus" name="agentStatus" id="agentStatus" disabled />
                    <span></span>
                    ยุติการเป็นผู้แทนจำหน่าย
                  </label>
                </div>
              </div>
            </div>
              
            </div>

            <!-- End:Map element -->
           
           
            <div class="col-xl-12">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input type="checkbox" class="form-check-input" v-model="status" name="status" id="status" />
                    <span></span>
                    เปิดใช้งาน
                  </label>
                </div>
              </div>
            </div>
            <div class="col-xl-12">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>ตัวแทน (สำนักงานใหญ่):</label>
                    <select2
                      :css-style="'width: 100%;'"
                      :css-class="'form-control'"
                      :id="'mappingToAgentCode'"
                      :name="'mappingToAgentCode'"
                      :select2-options="mappingToAgentCodeOptions"
                      v-model="smlMapping.mappingToAgentCode"
                      ref="mappingToAgentCode"
                    ></select2>
                    <span class="form-text"></span>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="form-group">
                    <label>ใช้งาน SML:</label>
                    <div class="form-check mt-3 pl-0">
                      <label class="form-check-label kt-checkbox">
                        <input type="checkbox" class="form-check-input" v-model="smlMapping.useMappingDocSML" name="status" id="status" />
                        <span></span>
                        เปิดอ้างอิงข้อมูลเอกสารจากระบบ SML
                      </label>
                      <label class="form-check-label kt-checkbox ml-3">
                        <input type="checkbox" class="form-check-input" v-model="smlMapping.useMappingShopSML" name="status" id="status" />
                        <span></span>
                        เปิดส่งข้อมูลร้านค้าจากระบบ SML
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="label">คลังอุปกรณ์เบียร์สด:</label>
                    <input type="text" class="form-control" v-model="smlMapping.whCode" placeholder="หากไม่ระบุจะใช้ DBS222" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="label">พื้นที่เก็บ (คลังหลักพร้อมขาย):</label>
                    <input type="text" class="form-control" v-model="smlMapping.location1Code" placeholder="หากไม่ระบุจะใช้ LC100" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="label">พื้นที่เก็บ (คลังถังเบียร์สด):</label>
                    <input type="text" class="form-control" v-model="smlMapping.location2Code" placeholder="หากไม่ระบุจะใช้ LC300" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-12">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>ยกยอดสินค้าในใบงานเร่ขายไปวันถัดไป:</label>
                    <div class="form-check">
                      <label class="form-check-label kt-checkbox">
                        <input type="checkbox" class="form-check-input" v-model="isPreviousBalance" name="isPreviousBalance" id="isPreviousBalance" />
                        <span></span>
                        เปิดใช้งาน
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>ใบงาน รับสินค้า/ทรัพย์สินจากลูกค้า และ เร่ขาย ไม่คืนคลังหลักพร้อมขายอัตโนมัติ:</label>
                    <div class="form-check">
                      <label class="form-check-label kt-checkbox">
                        <input type="checkbox" class="form-check-input" v-model="isNotReturnPlant" name="isNotReturnPlant" id="isNotReturnPlant" />
                        <span></span>
                        เปิดใช้งาน
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>ใบงานเร่ขาย กรณีส่งสินค้า โอนคืนคลังหลักพร้อมขายอัตโนมัติ:</label>
                    <div class="form-check">
                      <label class="form-check-label kt-checkbox">
                        <input type="checkbox" class="form-check-input" v-model="isReturnSaleProduct" name="isReturnSaleProduct" id="isReturnSaleProduct" />
                        <span></span>
                        เปิดใช้งาน
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                
              </div>
            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$router.go(-1)"><i class="la la-close"></i> ย้อนกลับ</button>
          <button type="submit" class="btn btn-primary"><i class="la la-save"></i> บันทึกข้อมูล</button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import select2 from "../../../Shared/Select2.vue";
import { VLazyImagePlugin } from "v-lazy-image";
import * as VueGoogleMaps from "vue2-google-maps";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

Vue.use(VLazyImagePlugin);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places",

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});
export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;
    return {
      agentCode: null,
      agentName: null,
      OwnerTypeCode: null,
      OwnerTypeCodeOption: [],
      adress: null,
      Area: null,
      Province: null,
      tel: null,
      email: null,
      lat: null,
      lng: null,
      FileUpload: [],
      status: null,
      markers: [],
      agentOnwer: null,
      agentContact: null,
      agentContactTel: null,
      agentStatus: false,
      IsSendReport: false,
      IsSpecialPM : false,
      isPreviousBalance: false,
      isNotReturnPlant: false,
      isReturnSaleProduct: false,
      isShowInAgentScoreReport: false,
      // CR-PM-2026 Req 2 — per-agent radius config (reserved for future agent-level checkin)
      useSettingCheckinRange: true,
      apiLoadedCheckInRange: undefined, // Issue 2: defensive — track fetched value
      customCheckInRange: null,
      customCheckInRangeMaxError: null,
      smlMapping: {
        mappingToAgentCode: null,
        useMappingDocSML: true,
        useMappingShopSML: true,
        whCode: null,
        location1Code: null,
        location2Code: null,
      },
      mappingToAgentCodeOptions: {
        placeholder: "เลือกตัวแทน (สำนักงานใหญ่)",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };

            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        language: {
          noResults: function() {
            return "ไม่พบข้อมูลตัวแทน (สำนักงานใหญ่)";
          },
        },
      },
      auAreaNew: null,
      auAreaNewOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterSalesArea/FindOptions",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  // mounted() {
  //   this.initPlUploader();
  // },
  methods: {
    // CR-PM-2026 Req 2 — reset to default (use Setting)
    resetCheckinRange: function() {
      this.useSettingCheckinRange = true;
      this.customCheckInRange = null;
    },
    checkCustomCheckInRangeMax(e) {
      const raw = e.target.value;
      const val = Number(raw);
      if (raw !== "" && !isNaN(val) && val > 10000) {
        this.customCheckInRangeMaxError = "ไม่สามารถกำหนดระยะทางเกิน 10,000 เมตร ได้";
        // Clamp value back to 10000 (block typing beyond)
        this.customCheckInRange = 10000;
        this.$nextTick(() => { if (e.target) e.target.value = 10000; });
      } else {
        this.customCheckInRangeMaxError = null;
      }
    },
    getMap: function() {
      //get current lat,lon by IP
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.markers = [
          {
            position: { lat: this.lat, lng: this.lng },
            animation: google.maps.Animation.DROP,
          },
        ];
      });
    },
    //get current lat,lng (dragable)
    updateCoordinates(location) {
      this.lat = location.latLng.lat();
      this.lng = location.latLng.lng();
      map: this.map;
      this.markers = [{ position: { lat: this.lat, lng: this.lng } }];
    },
    arrayBufferToBase64(buffer) {
      //var base64 = String.fromCharCode.apply(null, new Uint16Array(buffer));
      var base64 = btoa(buffer);
      return base64;
    },
    handleImageError(image) {
      image.isLoaded = false;
    },
    handleImageLoad(image) {
      image.isLoaded = true;
    },
    removeImage(pictureId) {
      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
      }).then((result) => {
        if (result.value) {
          this.FileUpload = this.FileUpload.filter(
            (img) => img.pictureId !== pictureId
          );
          Swal.fire("ลบสำเร็จ!", "ลบรูปภาพเรียบร้อยแล้ว", "success");
        }
      });
    },
    uploadFile() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.click();

      input.addEventListener("change", (event) => {
        const files = event.target.files;
        Array.from(files).forEach((file) => {
          if (
            ["image/jpeg", "image/jpg", "image/png"].includes(file.type) &&
            file.size <= 10 * 1024 * 1024
          ) {
            const reader = new FileReader();
            reader.onload = (e) => {
              const newImage = {
                pictureId: Date.now().toString(),
                fileName: file.name,
                urlImg: e.target.result,
                fileDataContext: file,
                isNew: true,
                isLoaded: true,
              };
              this.FileUpload.push(newImage);
            };
            reader.readAsDataURL(file);
          } else {
            alert(
              "กรุณาเลือกไฟล์ภาพที่ถูกต้อง (JPG, JPEG, PNG ขนาดไม่เกิน 10MB)"
            );
          }
        });
      });
    },
    async formSubmit(e) {
      let router = this.$router;
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let uploadedFiles = [];

      // Upload new files to GCS
      for (let file of this.FileUpload) {
        if (file.isNew && file.fileDataContext) {
          try {
            const formData = new FormData();
            formData.append("File", file.fileDataContext);
            formData.append("IsMaster", true);
            formData.append("FolderName", "MasterAgent");

            const uploadResponse = await axios.post("/Api/File/FileUpload", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });

            uploadedFiles.push({
              contentType: "-",
              downloadUrl: uploadResponse.data.fileUrl,
              fileInfoId: uploadResponse.data.fileInfoId,
              fileName: uploadResponse.data.fileInfoId,
              gridFsId: uploadResponse.data.gridFsId,
              sysName: "-",
            });
          } catch (error) {
            console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", error);
          }
        } else if (!file.isNew) {
          // Keep existing files
          uploadedFiles.push(file);
        }
      }

      const picturesData = uploadedFiles.length > 0 ? uploadedFiles : [];

      axios
        .put("/Api/Agents", {
          AgentCodeSap: this.agentCode,
          OwnerTypeCode: this.OwnerTypeCode,
          Email: this.email,
          InActiveStatus: !this.status,
          Tel: this.tel,
          Latitude: this.lat,
          Longitude: this.lng,
          AgentPictures: picturesData,
          SalesAreaId: this.auAreaNew,
          smlMapping: this.smlMapping,
          isPreviousBalance: this.isPreviousBalance,
          isNotReturnPlant: this.isNotReturnPlant,
          IsSendReport: this.IsSendReport,
          IsSpecialPM : this.IsSpecialPM,
          isReturnSaleProduct: this.isReturnSaleProduct,
          isShowInAgentScoreReport: this.isShowInAgentScoreReport,
          // CR-PM-2026 Req 2 — radius
          UseSettingCheckinRange: this.useSettingCheckinRange,
          CheckInRange: this.useSettingCheckinRange ? null : this.customCheckInRange,
        })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(function() {
              router.go(-1), self.$parent.reloadDataTable(false);
            });
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    openMap() {
      var self = this;
      window.open("https://www.google.com/maps/search/?api=1&query=" + self.lat + "," + self.lng, "_blank");
    },
    LoadOwnerTypeCodeOption: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=MASTER_OWNER_TYPE", {
          params: {
            page: 1,
            all: true,
            searchCode: "OWNER_AGENT"
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.OwnerTypeCodeOption.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();
    self.LoadOwnerTypeCodeOption();

    $(this.$refs.form).validate({
      // CR-PM-2026 Issue 14: required เฉพาะกรณี "กำหนดเอง" (useSettingCheckinRange=false)
      rules: {
        customCheckInRange: {
          required: function() { return !self.useSettingCheckinRange; }
        }
      },
      messages: {
        customCheckInRange: "กรุณาระบุระยะ (เมตร)"
      }
    });

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .get("/Api/Agents/" + this.$route.params.AgentID)
      .then(function(response) {
        if (response.status == 200) {
          self.agentCode = response.data.agentCodeSap;
          self.agentName = response.data.agentName;
          self.adress = response.data.address;
          self.Area = response.data.department;
          self.Province = response.data.provinceName;
          self.tel = response.data.tel;
          self.email = response.data.email;
          self.agentOnwer = response.data.owner;
          self.agentContact = response.data.contact;
          self.agentContactTel = response.data.contactTel;
          self.agentStatus = !response.data.agentStatus;
          self.IsSendReport = response.data.isSendReport;
          self.IsSpecialPM = ( response.data.isSpecialPM != null) ? response.data.isSpecialPM  : false ;
          self.isPreviousBalance = response.data.isPreviousBalance;
          self.isNotReturnPlant = response.data.isNotReturnPlant;
          self.isReturnSaleProduct = response.data.isReturnSaleProduct;
          self.isShowInAgentScoreReport = response.data.isShowInAgentScoreReport;
          // CR-PM-2026 Req 2 — load radius config
          self.useSettingCheckinRange = (response.data.useSettingCheckinRange != null) ? response.data.useSettingCheckinRange : true;
          self.customCheckInRange = (!self.useSettingCheckinRange) ? response.data.checkInRange : null;
          self.apiLoadedCheckInRange = (response.data.checkInRange != null) ? response.data.checkInRange : null;
          self.OwnerTypeCode = response.data.ownerTypeCode;
          if (response.data.salesAreaId) {
            self.$refs.auAreaNewSelect2.setSelectedData({
              id: response.data.salesAreaId,
              text: response.data.salesAreaName,
            });
          }

          response.data.latitude === null ? (self.lat = null) : (self.lat = parseFloat(response.data.latitude));

          response.data.longitude === null ? (self.lng = null) : (self.lng = parseFloat(response.data.longitude));

          self.markers = [{ position: { lat: self.lat, lng: self.lng } }];
          self.status = !response.data.inActiveStatus;

          // Load existing images to FileUpload array (GCS format)
          self.FileUpload = response.data.pictures.map((element) => ({
            pictureId: element.pictureId,
            fileName: element.fileName,
            fileInfoId: element.fileInfoId,
            downloadUrl: element.downloadUrl,
            urlImg: element.urlImg,
            gridFsId: element.gridFsId,
            sysName: element.sysName,
            isNew: false,
            isLoaded: true,
          }));

          let smlMapping = response.data.smlMapping;
          self.smlMapping.useMappingDocSML = smlMapping.useMappingDocSML;
          self.smlMapping.useMappingShopSML = smlMapping.useMappingShopSML;
          self.smlMapping.whCode = smlMapping.whCode;
          self.smlMapping.location1Code = smlMapping.location1Code;
          self.smlMapping.location2Code = smlMapping.location2Code;
          if (smlMapping.mappingToAgentCode) {
            self.$refs.mappingToAgentCode.setSelectedData({
              id: smlMapping.mappingToAgentCode,
              text: "[" + smlMapping.mappingToAgentCode + "] " + smlMapping.mappingToAgentName,
            });
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลตัวแทนจำหน่ายที่คุณเลือก", "warning");
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลตัวแทนจำหน่ายได้ในขณะนี้", "error");
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  },
};
</script>

<style lang="scss">
#myProgress {
  width: 100%;
  background-color: #ddd;
}

.myBar {
  width: 10%;
  height: 30px;
  background-color: #4caf50;
  text-align: center;
  line-height: 30px;
  color: white;
}

.btm-reload-img-agent {
  position: absolute;
  top: 5px;
  right: 20px;
}
.btm-delete-img-agent {
  position: absolute;
  top: 5px;
  right: 70px;
}
.btm-remove-img-agent {
  position: absolute;
  top: 5px;
  right: 20px;
}

.select2,
.select2-dropdown {
  font-size: 1.2rem;
}

@media (max-width: 425px) {
  .m-body .m-content {
    padding: 20px 5px;
  }
}

@media (max-width: 1200px) {
  .m-wizard.m-wizard--2 {
    margin-top: 8rem !important;
  }

  #activity_wizard .m-wizard__form .m-form .m-portlet__body {
    padding: 2.2rem 0 !important;
  }
}

.select2,
.select2-dropdown {
  font-size: 1rem;
}
</style>


// WEBPACK FOOTER //
// App/Components/Master/Agent/AgentUpdate.vue